import { render, staticRenderFns } from "./ExamSimulation.vue?vue&type=template&id=3c6d0332&scoped=true&"
import script from "./ExamSimulation.vue?vue&type=script&lang=js&"
export * from "./ExamSimulation.vue?vue&type=script&lang=js&"
import style0 from "./ExamSimulation.vue?vue&type=style&index=0&id=3c6d0332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6d0332",
  null
  
)

export default component.exports